/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Import_Settings_ValidatorInputs */



/**
* | output |
* | --- |
* | "Max Lines and Max Characters Per Line must be whole numbers of 1 or greater." |
*
* @param {Ai_Import_Settings_ValidatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_import_settings_validator = /** @type {((inputs?: Ai_Import_Settings_ValidatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Import_Settings_ValidatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Max lignes et Max caractères par ligne doivent être des nombres entiers supérieurs ou égaux à 1.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeilen und maximale Zeichen pro Zeile müssen ganze Zahlen ab 1 sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Max righe e Max caratteri per riga devono essere numeri interi maggiori o uguali a 1.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимум строк и максимум символов в строке должны быть целыми числами не меньше 1.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máx. líneas y Máx. caracteres por línea deben ser números enteros iguales o mayores que 1.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每个事件的最大行数和每行最大字符数必须是大于或等于 1 的整数。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大行数と1行あたりの最大文字数は、1 以上の整数で入力してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम पंक्तियाँ और प्रति पंक्ति अधिकतम वर्ण 1 या उससे अधिक पूर्ण संख्याएँ होनी चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Máx. de linhas e Máx. de caracteres por linha têm de ser números inteiros iguais ou superiores a 1.")
	return /** @type {LocalizedString} */ ("Max Lines and Max Characters Per Line must be whole numbers of 1 or greater.")
});